module.exports = __webpack_public_path__ + "static/media/obst_icon.ecb59cb2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/obst_icon.svg
// module id = 152
// module chunks = 0